import logo from '../../assets/logo.svg';
import { Button, Dropdown } from 'antd';
import './BlogNavbar.css';
import { MenuOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';

export function BlogNavbar() {
  const getTargetUrl = () => {
    return process.env.REACT_APP_WEB_APP_URL;
  };

  const items = [
    {
      key: '1',
      label: (
        <NavLink to="/">
          Home
        </NavLink>
      ),
    },
    {
      key: '2',
      label: (
        <NavLink to="/blog">
          Blog
        </NavLink>
      ),
    },
    {
      key: '3',
      label: (
        <NavLink to="/" target="_blank">
          <Button size="large">Public Status Page</Button>
        </NavLink>
      ),
    },
    {
      key: '4',
      label: (
        <NavLink to={getTargetUrl()!} target="_blank">
          <Button type="primary" size="large">
            Sign In
          </Button>
        </NavLink>
      ),
    },
  ];

  return (
    <nav className="nav">
      <div className="container flex-row plr-page">
        <div className="logo">
          <NavLink to="/">
            <img src={logo} alt="logo" />
          </NavLink>
        </div>
        <Dropdown className="hoverable nav-desktop-hidden" menu={{ items }} placement="bottomLeft">
          <MenuOutlined style={{ fontSize: '28px', color: '#1e1e1e' }} />
        </Dropdown>
        <div className="nav-links nav-mobile-hidden">
          <NavLink to="/" className="text">
            Home
          </NavLink>
          <NavLink to="/blog" className="text">
            Blog
          </NavLink>
        </div>
        <Button onClick={() => window.open('/status', '_blank')} className="nav-mobile-hidden" size="large">
          Public Status Page
        </Button>
        <Button
          onClick={() => window.open(getTargetUrl(), '_blank')}
          className="nav-mobile-hidden"
          type="primary"
          size="large"
        >
          Sign In
        </Button>
      </div>
    </nav>
  );
}